if (!customElements.get('predictive-search')) {
  class PredictiveSearch extends HTMLElement {
    constructor() {
      super();

      this.input = this.querySelector('input[type="search"]');
      this.resultsContainer = this.querySelector(
        '.js-results-container'
      );
      this.btnSubmit = this.querySelector('.js-btn-submit');
      this.btnClearText = this.querySelector('.js-btn-clear-text');
      this.errorMessageContainer = this.querySelector(
        '.js-message-error'
      );
      this.errorMessageText =
        this.errorMessageContainer.querySelector('[data-text]');
      this.timeout = null;
      this.isOpen = false;
      this.drawer = this.closest('.js-drawer');

      var searchDrawerContent = document.querySelector('.drawer__content--search');
      var searchSuggestions = document.querySelector('.search-drawer__suggestions');

      this.input.addEventListener('input', e => {
        clearTimeout(this.timeout);

        this.timeout = setTimeout(() => {
          const searchTerm = this.input.value.trim();

          if (searchTerm.length <= 0) {
            this.close();
            if(DeviceDetector.isMobile() || DeviceDetector.isTablet()) {
              searchDrawerContent.style.height = 'auto';
            }
            if(searchSuggestions) {
              searchSuggestions.style.display = 'block';
            }
            return;
          }

          this.isOpen = true;
          this.getSearchResults(searchTerm);
          if(DeviceDetector.isMobile() || DeviceDetector.isTablet()) {
            searchDrawerContent.style.height = '100%';
          }
          if(searchSuggestions) {
            searchSuggestions.style.display = 'none';
          }
        }, 300);
      });

      this.input.addEventListener('keydown', e => {
        const isEscape = e.key === 'Escape';

        if (!isEscape) {
          return;
        }

        if (!this.input.value) {
          if (this.drawer) {
            this.drawer.parentElement.parentElement.toggleDrawer();
          }

          return;
        }

        this.close();
      });

      this.btnClearText.addEventListener('click', e => {
        this.close();
        searchDrawerContent.style.height = 'auto';
        if(searchSuggestions) {
          searchSuggestions.style.display = 'block';
        }
      });
    }

    async getSearchResults(searchTerm) {
  try {
    const cleanSearchTerm = String(searchTerm || '')
      .trim()
      .replace(/\s+/g, ' ');

    const params = new URLSearchParams({
  q: cleanSearchTerm,
  'resources[type]': 'product,collection,query',
  'resources[limit]': '8',
  'resources[options][fields]': 'title,body',
  section_id: 'predictive-search'
});

    const response = await fetch(
      `${Shopify.routes.root}search/suggest?${params.toString()}`
    );

    if (!this.isOpen) {
      return;
    }

    if (!response.ok) {
      throw new Error(response.status);
    }

    const text = await response.text();

    const parsedDocument =
      new DOMParser().parseFromString(
        text,
        'text/html'
      );

    const predictiveSection =
      parsedDocument.querySelector(
        '#shopify-section-predictive-search'
      );

    if (!predictiveSection) {
      throw new Error(
        'Predictive search response is missing.'
      );
    }

    this.resultsContainer.innerHTML =
      predictiveSection.innerHTML;

    this.open();

    document
      .querySelector('quick-cart-drawer')
      ?.initTriggers();
  } catch (error) {
    this.errorMessageText.textContent =
      error.message;

    this.errorMessageContainer.classList.remove(
      'hidden'
    );
  }
}

    open() {
      this.classList.add('is-open');
      this.resultsContainer.classList.remove('hidden');
      this.errorMessageContainer.classList.add('hidden');
      this.btnSubmit.setAttribute('tabindex', '-1');
      this.btnClearText.removeAttribute('disabled');
    }

    close() {
      this.isOpen = false;
      this.classList.remove('is-open');
      this.resultsContainer.classList.add('hidden');
      this.errorMessageContainer.classList.add('hidden');
      this.input.value = '';
      this.input.focus();
      this.btnSubmit.removeAttribute('tabindex');
      this.btnClearText.setAttribute('disabled', true);
    }
  }

  customElements.define('predictive-search', PredictiveSearch);
}
